<template>
  <div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`biztositott_nev_${listName}_${pKey}`"
        >Név <span v-if="selectable" class="text-danger">*</span></label
      >
      <ValidationProvider
        rules="required"
        :name="`biztositott_nev_${listName}_${pKey}`"
        v-slot="{errors, classes}"
        class="col-sm-8"
        v-if="selectable"
      >
        <input
          class="form-control"
          type="text"
          v-model="name"
          :id="`biztositott_nev_${listName}_${pKey}`"
          :class="classes"
          required
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
      <div class="col-sm-8" v-else>
        {{ name }}
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`biztositott_nev_${listName}_${pKey}`"
        >Születési dátum <span v-if="selectable" class="text-danger">*</span></label
      >
      <div class="col-sm-8" v-if="selectable">
        <Datepicker
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="disabledDates"
          :typeable="false"
          v-model="bornDate"
          :bootstrap-styling="true"
          :required="true"
        ></Datepicker>
        <ValidationProvider
          :immediate="true"
          rules="required|szuletes_datum"
          :name="`biztositott_szul_${listName}_${pKey}`"
          v-slot="{errors}"
        >
          <input type="text" :value="bornDate" disabled hidden />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="col-sm-8" v-else>
        {{ new Date(bornDate).toLocaleDateString('hu-HU') }}
      </div>
    </div>
    <div class="form-group row" v-if="selectable">
      <label class="col-sm-4">
        Biztosított törlése<br />
        <span class="text-danger fw-normal">A törléssel a beírt adatok elvesznek.</span>
      </label>
      <div class="col-sm-8">
        <div class="btn btn-red w-100" @click="deleteInsuredPerson">Törlés</div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {hu} from 'vuejs-datepicker/dist/locale';

export default {
  props: ['pKey', 'person', 'selectable', 'listName'],
  components: {
    Datepicker,
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const minDate = new Date(today);
    // minDate.setFullYear(now.getFullYear() - 70);
    // minDate.setMonth(now.getMonth());
    // minDate.setDate(now.getDate() + 1);
    minDate.setFullYear(1900);
    if (this.listName === 'travelInsuranced') minDate.setFullYear(now.getFullYear() - 70);
    if (this.listName === 'burialInsuranced') minDate.setFullYear(now.getFullYear() - 65);
    minDate.setMonth(1);
    minDate.setDate(1);

    return {
      hu: hu,
      disabledDates: {
        customPredictor: function(date) {
          return date > today || date < minDate;
        },
      },
    };
  },
  computed: {
    name: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[this.pKey].name;
      },
      set(value) {
        this.$store.commit('updateInsuredPerson', {
          index: this.pKey,
          key: 'name',
          value: value,
          listName: this.listName,
        });
      },
    },
    bornDate: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[this.pKey].bornDate;
      },
      set(value) {
        this.$store.commit('updateInsuredPerson', {
          index: this.pKey,
          key: 'bornDate',
          value: value,
          listName: this.listName,
        });
      },
    },
  },
  methods: {
    deleteInsuredPerson() {
      if (!this.selectable) return;
      this.$store.commit('deleteInsuredPerson', {id: this.pKey, listName: this.listName});
    },
  },
};
</script>
